import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Input, Icon, Select, SelectItem, IndexPath } from '@ui-kitten/components';
import { StyleSheet, ScrollView } from 'react-native';
import { useDispatch, useSelector} from 'react-redux';
import {setCustumerName, setCustumerPhone, setCustumerAddress,setCustumerProvince, setCustumerCity} from '../../../store/actions/newAddress'
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';

var cities = [
  ['آذرشهر' ,'اسکو' ,'اهر' ,'بستان‌آباد' ,'بناب' ,'تبریز' ,'جلفا' ,'چاراویماق' ,'سراب' ,'شبستر', 'مراغه'],
  ['ارومیه' ,'اشنویه' ,'بوکان' ,'پیرانشهر' ,'تکاب' ,'چالدران' ,'خوی' ,'سردشت' ,'سلماس' ,'شاهین‌دژ' ,'ماکو' ,'مهاباد' ,'میاندوآب' ,'نقده'],
  ['اردبیل' ,'بیله‌سوار' ,'پارس‌آباد' ,'خلخال' ,'کوثر' ,'گِرمی' ,'مِشگین‌شهر' ,'نَمین' ,'نیر'],
  ['آران و بیدگل' ,'اردستان' ,'اصفهان' ,'برخوار و میمه' ,'تیران و کرون' ,'چادگان' ,'خمینی‌شهر' ,'خوانسار' ,'سمیرم' ,'شهرضا' ,'سمیرم سفلی' ,'فریدن' ,'فریدون‌شهر' ,'فلاورجان' ,'کاشان' ,'گلپایگان' ,'لنجان' ,'مبارکه' ,'نائین' ,'نجف‌آباد' ,'نطنز'],
  ['کرج', 'نظرآباد', 'فردیس', 'اشتهارد', 'هشتگرد', 'طالقان'],
  ['آبدانان' ,'ایلام' ,'ایوان' ,'دره‌شهر' ,'دهلران' ,'شیروان و چرداول' ,'مهران'],
  ['بوشهر' ,'تنگستان' ,'جم' ,'دشتستان' ,'دشتی','دیر' ,'دیلم' ,'کنگان' ,'گناوه'],
  ['اسلام‌شهر' ,'پاکدشت' ,'تهران' ,'دماوند' ,'رباط‌کریم' ,'ری' ,'ساوجبلاغ' ,'شمیرانات' ,'شهریار' ,'فیروزکوه' ,'ورامین'],
  ['اردل' ,'بروجن' ,'شهرکرد' ,'فارسان' ,'کوهرنگ' ,'لردگان'],
  ['بیرجند' ,'درمیان' ,'سرایان' ,'سربیشه' ,'فردوس' ,'قائنات','نهبندان'],
  ['بردسکن' ,'تایباد' ,'تربت جام' ,'تربت حیدریه' ,'چناران' ,'خلیل‌آباد' ,'خواف' ,'درگز' ,'رشتخوار' ,'سبزوار' ,'سرخس' ,'فریمان' ,'قوچان' ,'کاشمر' ,'کلات' ,'گناباد' ,'مشهد' ,'مه ولات' ,'نیشابور'],
  ['اسفراین' ,'بجنورد' ,'جاجرم' ,'شیروان' ,'فاروج' ,'مانه و سملقان'],
  ['آبادان' ,'امیدیه' ,'اندیمشک' ,'اهواز' ,'ایذه' ,'باغ‌ملک' ,'بندر ماهشهر' ,'بهبهان' ,'خرمشهر' ,'دزفول' ,'دشت آزادگان' ,'رامشیر' ,'رامهرمز' ,'شادگان' ,'شوش' ,'شوشتر' ],
  ['ابهر', 'ایجرود', 'خدابنده', 'خرمدره', 'زنجان', 'سلطانیه', 'طارم', 'ماهنشان'],
  ['دامغان' ,'سمنان' ,'شاهرود' ,'گرمسار' ,'مهدی‌شهر'],
  ['ایرانشهر' ,'چابهار' ,'خاش' ,'دلگان' ,'زابل' ,'زاهدان' ,'زهک' ,'سراوان' ,'سرباز' ,'کنارک' ,'نیک‌شهر'],
  ['آباده' ,'ارسنجان' ,'استهبان' ,'اقلید' ,'بوانات' ,'پاسارگاد' ,'جهرم' ,'خرم‌بید' ,'خنج' ,'داراب' ,'زرین‌دشت' ,'سپیدان' ,'شیراز' ,'فراشبند' ,'فسا' ,'فیروزآباد' ,'قیر و کارزین' ,'کازرون' ,'لارستان' ,'لامِرد' ,'مرودشت' ,'ممسنی' ,'مهر' ,'نی‌ریز'],
  ['آبیک' ,'البرز' ,'بوئین‌زهرا' ,'تاکستان' ,'قزوین'],
  ['قم'],
  ['بانه' ,'بیجار' ,'دیواندره' ,'سروآباد' ,'سقز' ,'سنندج' ,'قروه' ,'کامیاران' ,'مریوان'],
  ['بافت' ,'بردسیر' ,'بم' ,'جیرفت' ,'راور' ,'رفسنجان' ,'رودبار جنوب' ,'زرند' ,'سیرجان' ,'شهر بابک' ,'عنبرآباد' ,'قلعه گنج' ,'کرمان' ,'کوهبنان' ,'کهنوج' ,'منوجان'],
  ['اسلام‌آباد غرب' ,'پاوه' ,'ثلاث باباجانی' ,'جوانرود' ,'دالاهو' ,'روانسر' ,'سرپل ذهاب' ,'سنقر' ,'صحنه' ,'قصر شیرین' ,'کرمانشاه' ,'کنگاور' ,'گیلان غرب' ,'هرسین'],
  ['بویراحمد' ,'بهمئی' ,'دنا' ,'کهگیلویه' ,'گچساران'],
  ['آزادشهر' ,'آق‌قلا' ,'بندر گز' ,'ترکمن' ,'رامیان' ,'علی‌آباد' ,'کردکوی' ,'کلاله' ,'گرگان' ,'گنبد کاووس' ,'مراوه‌تپه' ,'مینودشت'],
  ['آستارا' ,'آستانه اشرفیه' ,'اَملَش' ,'بندر انزلی' ,'رشت' ,'رضوانشهر' ,'رودبار' ,'رودسر' ,'سیاهکل' ,'شَفت' ,'صومعه‌سرا' ,'طوالش' ,'فومَن' ,'لاهیجان' ,'لنگرود' ,'ماسال'],
  ['ازنا' ,'الیگودرز' ,'بروجرد' ,'پل‌دختر' ,'خرم‌آباد' ,'دورود' ,'دلفان' ,'سلسله ,کوهدشت'],
  ['آمل' ,'بابل' ,'بابلسر' ,'بهشهر' ,'تنکابن' ,'جویبار' ,'چالوس' ,'رامسر' ,'ساری' ,'سوادکوه' ,'قائم‌شهر' ,'گلوگاه' ,'محمودآباد' ,'نکا' ,'نور' ,'نوشهر'],
  ['آشتیان' ,'اراک' ,'تفرش' ,'خمین' ,'دلیجان' ,'زرندیه' ,'ساوه' ,'شازند' ,'کمیجان' ,'محلات'],
  ['ابوموسی' ,'بستک' ,'بندر عباس' ,'بندر لنگه' ,'جاسک' ,'حاجی‌آباد' ,'شهرستان خمیر' ,'رودان'  ,'قشم' ,'گاوبندی' ,'میناب'],
  ['اسدآباد' ,'بهار' ,'تویسرکان' ,'رزن' ,'کبودرآهنگ' ,'ملایر' ,'نهاوند' ,'همدان'],
  ['ابرکوه' ,'اردکان' ,'بافق' ,'تفت' ,'خاتم' ,'صدوق' ,'طبس' ,'مهریز' ,'مِیبُد' ,'یزد']
]

const ostan = [
  'آذربایجان شرقی',
  'آذربایجان غربی',
  'اردبیل',
  'اصفهان',
  'البرز',
  'ایلام',
  'بوشهر',
  'تهران',
  'چهارمحال بختیاری',
  'خراسان جنویی',
  'خراسان رضوی',
  'خراسان شمالی',
  'خوزستان',
  'زنجان',
  'سمنان',
  'سیستان و بلوچستان',
  'فارس',
  'قزوین',
  'قم',
  'کردستان',
  'کرمان',
  'کرمانشاه',
  'کهگیلویه و بویراحمد',
  'گلستان',
  'گیلان',
  'لرستان',
  'مازندران',
  'مرکزی',
  'هرمزگان',
  'همدان',
  'یزد'
]

const AgentIcon = (props) => (
  <Icon {...props} name='smiling-face'/>
);

const PhoneIcon = (props) => (
  <Icon {...props} name='phone-call'/>
);

const MapIcon = (props) => (
  <Icon {...props} name='map'/>
);


export const CustomerInfo = ({ navigation }) => {
  const [selectedIndex, setSelectedIndex] = useState(new IndexPath(0));
  const [ostanSelectedIndex, setOstanSelectedIndex] = useState(new IndexPath(0));

  const name = useSelector( state => state.newAddress.merchant_name);
  const phone = useSelector( state => state.newAddress.merchant_phone);
  const address = useSelector( state => state.newAddress.merchant_address);

  const dispatch = useDispatch();
  setTimeout(()=>{
    console.log(name);
  },5000)

  const selectProvince = async (index)=>{
    await setOstanSelectedIndex(index);
    await dispatch(setCustumerProvince(ostan[index-1]))
  }

  const selectCity = async (index)=>{
    await setSelectedIndex(index);
    await dispatch(setCustumerCity(cities[ostanSelectedIndex.row][index-1]))
  }
  return (
    <Layout level='3' style={{paddingHorizontal:15, marginVertical:5, paddingTop:5, paddingBottom:20, marginHorizontal:6, borderRadius:10}} >

        <Layout level='3' style={{flexDirection:'row', justifyContent:'space-between', marginTop:5}}>


          <Layout level='3' style={{flex:2}}>
            <Text category='c2' appearance='hint'> شماره تماس</Text>
            <Input
              placeholder ='موبایل'
              value={phone}
              accessoryLeft={PhoneIcon}
              onChangeText = {async(newValue) =>{
                dispatch(setCustumerPhone(newValue))
                if(newValue.length == 11){
                  console.log(newValue);
                  const response = await trackerApi.post('/invoice/getclients', {phone: newValue})
                  console.log(response.data.results[0]);
                  if(response.data.status && response.data.results.length > 0) {
                    dispatch(setCustumerName(response.data.results[0].name))
                    dispatch(setCustumerAddress(response.data.results[0].address))
                    // selectProvince(5)
                  }
                }
              }}
              keyboardType='numeric'
              maxLength={11}
              />
            </Layout>
          </Layout>
          <Layout level='3' style={{flex:2}}>
            <Text category='c2' appearance='hint'> نام مشتری</Text>
            <Input
              placeholder ='نام کامل مشتری'
              value={name}
              accessoryLeft={AgentIcon}
              onChangeText = {newValue =>{ dispatch(setCustumerName(newValue))}}

              />
            </Layout>
          <Text category='c2' style={{marginTop:10}} appearance='hint'> استان</Text>
          <Select
            selectedIndex={ostanSelectedIndex}
            value = {ostan[ostanSelectedIndex.row]}
            onSelect={index => selectProvince(index)}>
            {
              ostan.map((data)=>{
                return (
                  <SelectItem title={data} key={ostanSelectedIndex} />
                )
              })
            }
          </Select>

          <Text category='c2' style={{marginTop:10}} appearance='hint'> شهرستان</Text>
          <Select
            selectedIndex={selectedIndex}
            value = {cities[ostanSelectedIndex.row][selectedIndex-1]}

            onSelect={index => selectCity(index)}>
            {
              cities[ostanSelectedIndex.row].map((data)=>{
                return (
                  <SelectItem title={data} key={selectedIndex}/>
                )
              })
            }

          </Select>

          <Text category='c2' style={{marginTop:10}} appearance='hint'> آدرس</Text>
          <Input
            placeholder ='آدرس کامل'
            value= {address}
            accessoryLeft={MapIcon}
            multiline={true}
            onChangeText = {newValue =>{ dispatch(setCustumerAddress(newValue))}}
            />
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
  },
});
